import React from 'react'
import PropTypes from 'prop-types'
import SignupLayout from '../../components/layouts/SignupLayout'
import { ComponentSelect } from '../../components/auth/workflows'

const Signup = ({ siteData }) => {
  const [Component, props] = ComponentSelect(siteData)
  return <Component {...props} />
}

Signup.Layout = SignupLayout
Signup.propTypes = {
  siteData: PropTypes.object
}

export default Signup
